import React, {useState, useEffect} from 'react';
import { useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import moment from 'moment';
import { Footer } from '../footer';
import Header from '../header';
import Chatbot from '../askeva/chatbot';
import { error_api_call } from '../../actions/action-creators/common';
import { useCoinAnimation } from '../../context/CoinAnimationContext'; 

function WrapMaster(props) {
    var userReduxData = useSelector(state => state.auth);
    userReduxData = (localStorage.getItem("token") && userReduxData && userReduxData.user_info) ? JSON.parse(userReduxData.user_info) : null;
    var userReduxValidity = useSelector(state => state.stateUpdate);
    userReduxValidity = userReduxValidity && userReduxValidity.validity_data ? JSON.parse(userReduxValidity.validity_data) : null;
    const windowPath = window.location.pathname.split('/')[1];
    const { walletCoins } = useCoinAnimation();
    const location = useLocation();
    const [redirectUri, setRedirectUri] = useState('');
     //Redirection Url
      useEffect(() => {
        const urlHandling = () => {
          try{
            const urlQuryString = location.search;
            const urlParam = new URLSearchParams(urlQuryString);
            const urlRedirect = urlParam.get('redirect_uri');
            if(urlRedirect !== '' && urlRedirect !== null){
              setRedirectUri(urlRedirect);
            }
          }catch(e){
            error_api_call({error: `components/wrapper/main|urlHandling|${e}`});
          }
        }
        urlHandling();
      }, []);// eslint-disable-line react-hooks/exhaustive-deps

    return (
      <>
        {(typeof props.showHeader === "undefined" || props.showHeader === true) && (
            <Header />
        )}
        <div className={`wrapper ${(typeof props.bgGrey === "undefined" || props.bgGrey === true) ? 'body-grey' : ''}`} style={{minHeight: '70vh'}}>
        {(typeof props.showLogo === "undefined" || props.showLogo === true) && (
        <section>
        <div className="container">
            <div className="row mt-4 mb-1">
            <div className={`${props.showLogin === true ? 'col-lg-2 ' : 'col-lg-3'} col-md-3 col-6 col-sm-6 text-center`}>
                <img className="header-image" alt="International Foundation for Sustainable Peace and Development" src={require('../../assets/images/main/logo/ifspd_logo_m.png')} title="International Foundation for Sustainable Peace and Development" />
            </div>
            <div className={`${props.showLogin === true ? 'col-lg-2 ' : 'col-lg-3'} col-md-3 col-6 col-sm-6 text-center d-md-none d-block`}>
                <img className="header-image" alt="ECOSOC" src={require('../../assets/images/main/logo/ecosoc.png')} title="ECOSOC" />
            </div>
            <div className={`${props.showLogin === true ? 'col-xl-4 col-lg-3' : 'col-lg-6'} col-md-6 col-12 col-sm-12 mb-2 text-center`}>
                <img alt="International Foundation for Sustainable Peace and Development" src={require('../../assets/images/main/logo/img-ifslogan-eng.png')} title="International Foundation for Sustainable Peace and Development" />
            </div>
            <div className={`${props.showLogin === true ? 'col-lg-2 ' : 'col-lg-3'} col-md-3 col-12 col-sm-12 text-center d-md-block d-none`}>
                <img className="header-image" alt="ECOSOC" src={require('../../assets/images/main/logo/ecosoc.png')} title="ECOSOC" />
            </div>
            {(typeof props.showLogin !== "undefined" && props.showLogin === true) && !(localStorage.getItem("token") && userReduxData) && (
                // <div className="btn-initiate mt-4 text-end">
                //     <button className="btn btn-primary bg-color-blue btn-glow"><a href={`/login${props.url ? `redirect_uri=/${props.url}` : ''}`}>Login</a></button>
                // </div>
                <div className="col-xl-4 col-lg-5 col-md-12 col-12 col-sm-12 text-center">
                <div className="btn-initiate log-btn-sec d-block d-sm-flex justify-content-center justify-content-md-end">
                <a href={`/register${redirectUri ? `?redirect_uri=${redirectUri}` : ''}`}><button className="btn btn-primary bg-color-blue ms-2 fw-bold mb-2">New Users Register</button></a>
                <a href={`/login${redirectUri ? `?redirect_uri=${redirectUri}` : ''}`}><button className="btn btn-primary fw-bold mb-2 ms-2">Existing Users Log In</button></a>
                </div>
                </div>
            )}
            </div>
        </div>
        </section>)}
        {/* <div className="site grid-container container hfeed grid-parent" id="page"> */}
        {/* <div className="site grid-container hfeed grid-parent" id="page"> */}
        <div className="site hfeed grid-parent" id="page">
            <div className="site-content" id="content">

                <div className="content-area grid-parent mobile-grid-100 grid-100 tablet-grid-100" id="primary">
                    <main className="site-main" id="main">
                        {(typeof props.showValidity !== "undefined"
                            && (windowPath === 'port' || windowPath === 'social-startup')
                            && props.showValidity
                            && localStorage.getItem("token")
                            && userReduxData
                            && userReduxValidity
                            && (userReduxValidity.port < 7 || userReduxValidity.ss < 7))
                            ?
                                (windowPath === 'port' && userReduxValidity.port < 7)
                                ?
                                    <div className={`mb-4 ${(typeof props.showLogo === "undefined" && props.showLogo === false) ? 'mt-60' : ''}`}>
                                        <div className={`alert alert-primary text-center`} role="alert">
                                            <p className="mb-1">Your Subscription is about to expire. Please renew it. <a href="/pay">Click Here</a></p>
                                            {(userReduxValidity.port_date || userReduxValidity.ss_date) && (
                                            <p className="mb-1">
                                                {userReduxValidity.port_date && (
                                                    <>Port: <span className="fw-bold">{moment(userReduxValidity.port_date).format("Do MMM YYYY")}</span></>
                                                )}
                                                {(userReduxValidity.port_date && userReduxValidity.ss_date) && (<span>&nbsp; | &nbsp;</span>)}
                                                {/* | */}
                                                {userReduxValidity.ss_date && (
                                                    <>Social Start-up: <span className="fw-bold">{moment(userReduxValidity.ss_date).format("Do MMM YYYY")}</span></>
                                                )}
                                            </p>
                                            )}
                                        </div>
                                    </div>
                                :   (windowPath === 'social-startup' && userReduxValidity.ss < 7)
                                    ?
                                        <div className={`mb-4 ${(typeof props.showLogo === "undefined" && props.showLogo === false) ? 'mt-60' : ''}`}>
                                            <div className={`alert alert-primary text-center`} role="alert">
                                                <p className="mb-1">Your Subscription is about to expire. Please renew it. <a href="/pay">Click Here</a></p>
                                                {(userReduxValidity.port_date || userReduxValidity.ss_date) && (
                                                <p className="mb-1">
                                                    {userReduxValidity.ss_date && (
                                                        <>Social Start-up: <span className="fw-bold">{moment(userReduxValidity.ss_date).format("Do MMM YYYY")}</span></>
                                                    )}
                                                    {(userReduxValidity.port_date && userReduxValidity.ss_date) && (<span>&nbsp; | &nbsp;</span>)}
                                                    {userReduxValidity.port_date && (
                                                        <>Port: <span className="fw-bold">{moment(userReduxValidity.port_date).format("Do MMM YYYY")}</span></>
                                                    )}
                                                </p>
                                                )}
                                            </div>
                                        </div> 
                                    :
                                    <></>
                            :
                            <></>
                        }
                            {/* <div className="mb-4">
                                <div className={`alert alert-primary text-center`} role="alert">
                                    <p className="mb-1">Your Subscription is about to expire. Please renew it. <a href="/pay">Click Here</a></p>
                                    {(userReduxValidity.port_date || userReduxValidity.ss_date) && (
                                    <p className="mb-1">
                                        {userReduxValidity.port_date && (
                                            <>Port: <span className="fw-bold">{moment(userReduxValidity.port_date).format("Do MMM YYYY")}</span></>
                                        )}
                                        |
                                        {userReduxValidity.ss_date && (
                                            <>Social Start-up: <span className="fw-bold">{moment(userReduxValidity.ss_date).format("Do MMM YYYY")}</span></>
                                        )}
                                    </p>
                                    )}
                                </div>
                            </div> */}
                        {/* <Navbar /> */}
                        {/* <div className="container-fluid container-lg"> */}
                            {/* <div className="row"> */}
                                {props.children}
                            {/* </div> */}
                        {/* </div> */}
                    </main>
			    </div>
		    </div>
	    </div>
        </div>
        {(typeof props.showFooter === "undefined" || props.showFooter === true) && (
            <Footer
                showPartner={props.showPartner}
                footerClass={props.footerClass||''}
                trimFooter={props.trimFooter||''}
            />
        )}
        {/* {(typeof props.showBot === "undefined"
            || props.showBot !== false
        ) && (
        //  {userReduxData && 
        //     (userReduxData.user_name === 'jagannath-girisaballa'
        //     || userReduxData.user_name === 'akshay-panchavati'
        //     || userReduxData.user_name === 'zac-sangeeth'
        //     || userReduxData.user_name === 'anna-jacob'
        //     || userReduxData.user_name === 'test-change'
        //     || userReduxData.user_name === 'ritika-kriti-singh')
        //     && (
        //         typeof props.showBot === "undefined"
        //             || props.showBot !== false
                
        //     )
        //     && (
            <Chatbot
                isCustom={false}
            />
        )} */}
        {/* )} */}
        {/* Wallet Coins for animation */}
        {walletCoins.map((coin) => (
            <div
            key={coin.id}
            className={`wallet-coin ${coin.visible ? "fly" : ""}`}
            style={{
                left: coin.startX,
                top: coin.startY,
                transform: coin.visible
                ? `translate(${coin.deltaX}px, ${coin.deltaY}px) scale(0.5)`
                : "translate(0, 0)",
            }}
            >
            <img className="sm-icon-50" src={require("../../assets/images/icon/celebrate/diamond.gif")} alt="points" />
            </div>
        ))}
      </>
    );
  }
  
  export default WrapMaster;